import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';
import { RecordResponse } from '../models/ServiceTypes';

// Define the GridColumnViewModel type
export interface GridColumnViewModel {
  GridColumnDataField: string;
  Order: number;
  Label: string;
  IsEnabled: boolean;
  IncludedInExport: boolean;
}

export const gridColumnsApi = createApi({
  reducerPath: 'gridColumnsApi',
  baseQuery: waServicesQuery,

  endpoints: (builder) => ({
    getGridColumns: builder.query<
      RecordResponse<GridColumnViewModel>,
      { gridKey: string }
    >({
      queryFn: async ({ gridKey }, _queryApi, __, baseQuery) => {
        const result = await baseQuery({
          url: `/api/user/gridColumns`,
          params: {
            gridKey,
            // Cache buster the legacy UI also sends. RTK's cache key comes from
            // the query arg, so this does not fragment the cache.
            _: Date.now(),
          },
          method: 'GET',
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data as RecordResponse<GridColumnViewModel> };
      },
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

export const { useGetGridColumnsQuery } = gridColumnsApi;
